<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} TRC AI CIRCLE LATEST UPDATE</template>
		<template #body>

			<div class="form-floating mb-4">
				<input type="text" v-model="form.blog_title" id="blog_title" name="blog_title" class="form-control" placeholder="Title" />
				<label class="form-label" for="blog_title">Title</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.vimeo_id" id="vimeo_id" name="vimeo_id" class="form-control" placeholder="Vimeo ID" />
				<label class="form-label" for="vimeo_id">Vimeo ID (optional)</label>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="blog_tag">Add Tag</label>
				<div class="input-group">
					<input type="text" v-model="blog_tag" id="blog_tag" name="blog_tag" class="form-control" placeholder="Tag">
					<span class="input-group-btn">
						<button @click="addTag" type="button" class="btn btn-info"><i class="fa fa-plus me1"></i>Add</button>
					</span>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="blog_title">Tags</label>
				<div class="mt-1">
					<span v-for="tag in blog_tags" class="badge border me-2 text-black">
						{{tag}} 
						<button @click="removeTag(tag)" type="button" class="btn-block-option ms-2 text-danger">x</button>
					</span>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="short_desc">Short Description</label>
				<div class="mt-1">
					<textarea v-model="form.short_desc" id="short_desc" class="form-control" rows="5"></textarea>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="blog_desc">Description</label>
				<!-- <div class="mb-2 text-muted">
					<p class="mb-1">Use this variable to customize the display</p>
					<span>[fname]</span>
					<span>[level]</span>
					<span>[expiry]</span>
				</div> -->
				<textarea id="ckeditor_trc_ai_circle_blog"></textarea>
			</div>
			<div class="form-floating mb-4">
				<div class="mb-4">
					<label class="form-label" for="blog_image">Image</label>
					<p class="text-danger fw-bold m-0">Recommended Size: width:1150px height:648px</p>
					<input
						@change="onFileChange"
						type="file"
						id="blog_image"
						name="blog_image"
						class="form-control"
						:accept="[
			            'image/jpeg',
			            'image/jpg',
			            'image/png'
			          ]"
					/>
				</div>
				<div class="mb-4">
					<div v-if="form.prev_blog_image!=null"
						class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
						style="height: 300px;background-size: contain;background-repeat: no-repeat;background-position: center;"
						:class="{'opacity-25':(form.blog_image!=form.prev_blog_image && form.prev_blog_image!=null && action=='update')}"
					>
						<img :src="form.blog_image_url" style="width:100%;" />
					</div>
					<div v-if="form.blog_image!=form.prev_blog_image && form.prev_blog_image!=null && action=='update'" class="text-center text-muted">
						<i class="fa fa-arrow-down fa-2x"></i>
					</div>
					<div>
						<div id="image-preview" 
						class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
						style="background-size: contain;background-repeat: no-repeat;background-position: center;"
						:style="{'height':(form.blog_image!=form.prev_blog_image)?'300px':'0px'}">
							
						</div>
						<div v-if="form.blog_image!=form.prev_blog_image && form.prev_blog_image!=null && action=='update'" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
					</div>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="start_datetime">Date Start</label>
				<flat-pickr
					v-model="form.date_start"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y',
						dateFormat: 'Y-m-d',
					}"
					class="form-control"
					:class="
						form.errors.start_date
							? 'flatpickr-input is-invalid border-danger'
							: 'flatpickr-input'
					"
				/>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="is_active">Status</label>
				<div class="mt-2">
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_on"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="1"
						/>
						<label class="form-check-label bg-alt-primary" for="ON">ON</label>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_off"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="0"
						/>
						<label class="form-check-label bg-alt-primary" for="OFF">OFF</label>
					</div>
				</div>
			</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Latest Update</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import CKEditorInit from './../../Shared/ckeditor-init';


export default {
	props: {
		
	},
	mounted(){

		CKEditorInit('ckeditor_trc_ai_circle_blog');
	},
	setup(props) {
		const modal = ref(null);

		// const editor 		= ref(ClassicEditor);
		const editor 		= ref(null);
		const editorConfig 	= {};

		const blog_tag = ref(null);

		const blog_tags = ref([]);
		
		const action = ref('add');

		const form = useForm({
			ai_circle_blog_uuid	: 0,
			blog_tags 			: null,
			blog_title 			: null,
			vimeo_id 			: null,
			short_desc 			: '',
			blog_desc 			: '',
			prev_blog_image 	: null,
			blog_image 			: null,
			blog_image_url 		: null,
			date_start 			: null,
			date_published 		: null,
			is_active 			: 0
		})

		const toggleModal = () => {
			
			if(action.value=='add')
			{
				// CKEDITOR.instances['ckeditor_trc_ai_circle_blog'].setData('<p></p>');
				window['ckeditor_trc_ai_circle_blog'].setData('<p></p>');
				blog_tags.value = [];
			}else
			{
				if(form.blog_desc!==null)
				{
					window['ckeditor_trc_ai_circle_blog'].setData(form.blog_desc);	
				}
				
			}

			modal.value.toggleModal();
			
		}

		const addTag = ()=>{
			
			blog_tags.value.push(blog_tag.value);
			
			configBlogTags();
			blog_tag.value = null;
		}

		const removeTag = (_level)=>{
			blog_tags.value = blog_tags.value.filter((data)=>{
				if(_level!=data)
				{
					return data;
				}
			})

			configBlogTags();
		}

		const configBlogTags = ()=>{
			if(blog_tags.value.length==0)
			{
				blog_tags.value 	= [];
				form.blog_tags 	= null;
			}else{
				for (var i = 0; i < blog_tags.value.length; i++) {
					var tag = blog_tags.value[i];
					if(i==0)
					{
						form.blog_tags = tag;
					}else{
						form.blog_tags += ","+tag;	
					}
					
				}
			}
		}

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#blog_image").val('');
		}

		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.blog_image = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.blog_image = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.blog_image = form.prev_blog_image;
			clearUpload();
		}

		const actionContent = ()=>{

			// form.description = CKEDITOR.instances['ckeditor_trc_ai_circle_blog'].getData();
			form.blog_desc = window['ckeditor_trc_ai_circle_blog'].getData();

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.trc-ai-circle.post.blogs'), {
				preserveState: true,
				preserveScroll: true,
				only:['trcAiCircleBlogs,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.post('blogs/'+form.ai_circle_blog_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['trcAiCircleBlogs,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setTrcAiCircleBlog = (_action,data)=>{
								
			form.reset();

			action.value = _action;

			if(_action=='update')
			{
				form.ai_circle_blog_uuid 	= data.ai_circle_blog_uuid;
				form.blog_title 			= data.blog_title;
				form.blog_tags 				= data.blog_tags;
				form.vimeo_id 				= data.vimeo_id;
				form.short_desc 			= data.short_desc;
				form.blog_desc 				= data.blog_desc;
				form.prev_blog_image 		= data.prev_blog_image;
				form.blog_image 			= data.blog_image;
				form.blog_image_url 		= data.blog_image_url;
				form.is_active 				= data.is_active;
				form.date_start 			= data.date_start;
				form.date_published 		= data.date_published;

				if(data.blog_tags!==null)
					blog_tags.value 			= data.blog_tags.split(",");

			}
			
		}


		return {
			form,
			blog_tag,
			blog_tags,
			modal,
			// editor,
			editorConfig,
			toggleModal,
			action,
			clearUpload,
			removeUploadImage,
			onFileChange,
			setTrcAiCircleBlog,
			addTag,
			removeTag,
			configBlogTags,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>

<style>
	.ck-content,.ck-source-editing-area{
		height: 300px;
	}
	
	.ck-content, .ck.ck-balloon-panel{
		z-index: 1055;
	}
</style>
